import { memo } from "react";

import { Money } from "@shopify/hydrogen-react";
import { type MoneyV2 } from "@shopify/hydrogen-react/storefront-api-types";

import { Text } from "@react/components/Text";
import { tw } from "classnames";

type Props = {
  cartLineChanging: boolean;
  discountedTotalAmount: Partial<MoneyV2> | undefined;
};

const styles = {
  container: tw("overflow-hidden"),
  cartLine: (cartLineChanging: boolean) =>
    tw("transition-opacity", {
      "opacity-50": cartLineChanging,
      "opacity-100": !cartLineChanging,
    }),
  discountTotal: tw("mb-1.5", "flex", "justify-between", "text-brick-700"),
};

const CartDiscountViewBase = ({
  cartLineChanging,
  discountedTotalAmount,
}: Props) => {
  return (
    <div className={styles.container}>
      <Text as="body2" className={styles.discountTotal}>
        Savings
        <span className={styles.cartLine(cartLineChanging)}>
          {!cartLineChanging && (
            <>
              -
              {discountedTotalAmount && discountedTotalAmount?.amount && (
                <Money
                  as="span"
                  data={discountedTotalAmount}
                  withoutTrailingZeros
                />
              )}
            </>
          )}
          {cartLineChanging && <span>---</span>}
        </span>
      </Text>
    </div>
  );
};

export const CartDiscountView = memo(CartDiscountViewBase);
